import { render, staticRenderFns } from "./GenerateCourseModal.vue?vue&type=template&id=3e0c7867&scoped=true"
import script from "./GenerateCourseModal.vue?vue&type=script&lang=js"
export * from "./GenerateCourseModal.vue?vue&type=script&lang=js"
import style0 from "./GenerateCourseModal.vue?vue&type=style&index=0&id=3e0c7867&prod&scoped=true&lang=css"
import style1 from "./GenerateCourseModal.vue?vue&type=style&index=1&id=3e0c7867&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c7867",
  null
  
)

export default component.exports